

import React, { useEffect, useState } from 'react'
import { Col, Row } from 'antd'
import { Link, useLocation } from 'react-router-dom'
import {  getPackageDomasticData } from '../../../services/holiday/holidayServices';


const AllDomesticPackage = () => {

    const location = useLocation();

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [packageData, setPackageData] = useState({});


    const fetchPackageData = () => {
        setLoading(true);
        getPackageDomasticData()
            .then((response) => {

                setPackageData(response)
                console.log("response", response)
            })
            .catch((error) => {
                setError(error.message || "An error occurred while fetching package data.");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchPackageData();
    }, [])

    return (
        <>

            <section className='PackageBanner'>
                <div className='container'>
                    <Row gutter={16} align="middle">
                        <Col md={16} sm={24}>
                            <div className='Package-cntr'>
                                <h2 className=''>Holiday Packages by Domestic Destination</h2>
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>

            <section className="room-area domestic-area ptb-70">
                <div className="container">
                    <div className="section-title"><div><h3>Holiday Packages by Domestic Destination</h3>
                        <span className="top-title">Search Holiday & Places Hire to our most popular destinations.</span></div>
                    </div>
                    <Row gutter={20}>

                        {packageData?.length > 0 ? (
                            packageData?.map((pkg, i) => (
                                <Col md={8} xs={24} key={i}>
                                    <div className="tr-trip-item mb-5">
                                        <div className="tr-trip-thumb fix">
                                            <Link aria-label="package link" to='/package-home'>
                                                <img loading="lazy" src={pkg?.package_gallery?.[0]?.image_url} alt="Holiday Mood" />
                                            </Link>
                                            {console.log("pkg?.package_gallery?.[0]?.mage_url", pkg?.package_gallery?.[0]?.image_url)}
                                        </div>
                                        <div className="tr-trip-content">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <div>
                                                    <h3 className="tr-trip-title mb-2">
                                                        <Link aria-label="package link" to='/package-home'>
                                                            {pkg?.package_name || 'Discover Palolem Beach'}
                                                        </Link>
                                                    </h3>
                                                    <h4>
                                                    <svg width="1em" height="1em" viewBox="-1.5 0 15 15" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill="#000000" fillRule="evenodd" d="M574,120 C575.324428,120 580,114.054994 580,110.833333 C580,107.611672 577.313708,105 574,105 C570.686292,105 568,107.611672 568,110.833333 C568,114.054994 572.675572,120 574,120 Z M574,113.333333 C575.420161,113.333333 576.571429,112.214045 576.571429,110.833333 C576.571429,109.452621 575.420161,108.333333 574,108.333333 C572.579839,108.333333 571.428571,109.452621 571.428571,110.833333 C571.428571,112.214045 572.579839,113.333333 574,113.333333 Z" transform="translate(-568 -105)"></path> </g></svg>
                                                        {pkg?.package_destination}, {pkg?.package_country}
                                                    </h4>
                                                </div>
                                                <div className="tr-trip-price text-end">
                                                    <del className="del">{pkg?.package_price}</del>
                                                    <h3>₹{pkg?.package_price}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            ))
                        ) : (
                            <div>Loading packages...</div>
                        )}

                    </Row>
                </div>
            </section>

        </>
    )
}

export default AllDomesticPackage
